<template>
  <define-scrollable-template>
    <div
      v-style:py="{ sm: '200%', md: '0' }"
      class="z-1 grid w-2/5 gap-2 <md:px-4 <md:grid-area-stack"
      :class="{
        'ml-a': config.position === 'left',
        'mr-a': config.position !== 'left',
      }"
    >
      <slot />
    </div>
  </define-scrollable-template>
  <div class="relative flex items-start gap-2 <md:grid">
    <scrollable-template v-if="config.position === 'right'" />
    <div ref="elRef" class="sticky top-0 md:w-3/5 <md:grid-area-stack">
      <base-parallax
        :root-margin
        :scale
        :should-always-complete-animation="true"
      >
        <slot name="main" />
      </base-parallax>
    </div>

    <scrollable-template v-if="config.position === 'left'" />
  </div>
</template>

<script setup lang="ts">
import type { GalleryCardsParallaxConfig } from '#types/components/cms/collection'
import type { ScaleOpacityEffect } from 'parallax-controller'

const { config } = defineProps<{
  config: GalleryCardsParallaxConfig
}>()

const scaleMap: Record<number, number> = {
  0: 1,
  1: 1.15,
  2: 1.25,
  3: 1.5,
  4: 1.75,
  5: 2,
}

const { $viewport } = useNuxtApp()
const [DefineScrollableTemplate, ScrollableTemplate] = createReusableTemplate()
const elRef = useTemplateRef('elRef')
const { height } = useElementBounding(elRef)

const rootMargin = computed(() => ({
  top: 0,
  right: 0,
  bottom: height.value * 2,
  left: 0
}))

const scale = computed<ScaleOpacityEffect>(
  () => $viewport.breakpoint === 'sm' ? [1, scaleMap[config.imageScaleSm || 1]] : [1, 1]
)
</script>
